import React, { useContext } from "react";
import { Button, Modal } from "Shared/ui";
import { CreateIbanAccount } from "./create_iban_account";
import { CreatePaypalAccount } from "./create_paypal_account";
import { WithdrawModalsContext } from "../context/WithdrawModalContext";
import "../withdraw_modals.scss";

export const CratePayingMethod = () => {
	const { isVisible, onCancelCreate, errors, method, onConfirmCreate } = useContext(WithdrawModalsContext);

	const title = method === "iban" ? "Add IBAN" : "Add PayPal";

	const buttons = [
		<Button
			type="bordered-azure"
			key={"cancel"}
			text="Cancel"
			onClick={onCancelCreate}
			className="withdraw-modal__button mr-10"
		/>,
		<Button type="azure" key={"ok"} text="Add" onClick={onConfirmCreate} disabled={JSON.stringify(errors) !== "{}"} />,
	];

	return (
		<Modal isVisible={isVisible} buttons={buttons} title={title}>
			<div className="withdraw-modal">
				{method === "iban" && <CreateIbanAccount />}
				{method === "paypal" && <CreatePaypalAccount />}
			</div>
		</Modal>
	);
};
